import {
  isDateTimeInPast
} from './scheduleUtils';

export const ALLOWED_EDIT_STATUSES = new Set(['processing', 'paused', 'stopped', 'draft']);
export function shouldShowEdit(campaign) {
  const status = String(campaign?.status || '').toLowerCase();
  return ALLOWED_EDIT_STATUSES.has(status) && campaign?.schedule?.schedule_type === 'ongoing';
}

// Fields editable during ongoing edit
const EDITABLE_FIELDS_ONGOING = new Set([
  'name', 'workspace_id', 'days_of_week', 'end_time', 'start_time', 'holidays',
  'webhook_queue_delay_days',
  'duplicate_data_rule_enabled',
  'duplicate_data_rule_days',
]);



// Updated canEditField with timezone check for start_date/start_time
export function canEditField(field, isEditing = false, formData = {}, timezone = 'UTC') {
  if (!isEditing) return true;

  if (field === 'duplicate_data_rule_enabled' || field === 'duplicate_data_rule_days') {
    return true;
  }

  if (field === 'webhook_queue_delay_days' && String(formData?.type || '').toLowerCase() === 'triggered') {
    return true;
  }

  if (field === 'call_group_mode') {
    if (String(formData?.type || '').toLowerCase() !== 'triggered') {
      return true;
    }
    const s = String(formData?.status || '').toLowerCase();
    if (s === 'completed') {
      return false;
    }
    return true;
  }

  // If campaign is stopped, allow start fields
  if (formData?.status === 'stopped' && ['start_time', 'timezone','timezone','start_date'].includes(field)) {
    return true;
  }

  if (!EDITABLE_FIELDS_ONGOING.has(field)) return false;

  // Disable start_date, start_time if campaign has started
  // if (['start_date'].includes(field) &&
  //     formData.start_date && formData.start_time) {

  //   const isPast = isDateTimeInPast(
  //     formData.start_date,
  //     formData.start_time,
  //     formData.timezone || "Asia/Kolkata"
  //   );
  //   if (isPast) return false;
  // }

  return true;
}

